/* Sainté: poseikonet på produktkortet åbner temaets størrelsesrække.
   Selve købet klarer temaets ProductCard i app.js: et klik på en
   størrelse lægger varen i kurven. Her styres kun åben og lukket. */
(() => {
  const OPEN = 'sainte-card--sizes';

  const close = (card) => {
    card.classList.remove(OPEN);
    const bag = card.querySelector('[data-sainte-sizes]');
    if (bag) bag.setAttribute('aria-expanded', 'false');
  };
  const closeAll = (except) => {
    document.querySelectorAll('.' + OPEN).forEach((card) => {
      if (card !== except) close(card);
    });
  };

  document.addEventListener('click', (e) => {
    const bag = e.target.closest('[data-sainte-sizes]');
    if (bag) {
      e.preventDefault();
      const card = bag.closest('.sainte-card');
      closeAll(card);
      card.classList.add(OPEN);
      bag.setAttribute('aria-expanded', 'true');
      return;
    }
    if (!e.target.closest('.' + OPEN)) closeAll();
  });

  // mouseleave bobler ikke, men kan fanges i capture-fasen.
  document.addEventListener('mouseleave', (e) => {
    if (e.target.classList && e.target.classList.contains(OPEN)) close(e.target);
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('cart:item-added', () => closeAll());
})();
